import type { Theme } from '@mui/material/styles';
import type { Components } from '@mui/material/styles';

// ----------------------------------------------------------------------

// v9 only styles palette keys and textPrimary/Secondary/Disabled itself.
const isColorHandledByMui = (theme: Theme, color: string): boolean => {
  if (/^text(Primary|Secondary|Disabled)$/.test(color)) {
    return true;
  }
  const paletteColor: unknown = Reflect.get(theme.palette, color);
  return (
    typeof paletteColor === 'object' &&
    paletteColor !== null &&
    'main' in paletteColor &&
    typeof paletteColor.main === 'string'
  );
};

export default function Typography(
  theme: Theme
): Pick<Components, 'MuiTypography'> {
  return {
    MuiTypography: {
      styleOverrides: {
        // Keeps v7 color="grey.600" / "text.secondary" / raw CSS colors working.
        root: ({ ownerState }) =>
          typeof ownerState.color === 'string' &&
          !isColorHandledByMui(theme, ownerState.color)
            ? theme.unstable_sx({ color: ownerState.color })
            : {},
        gutterBottom: {
          marginBottom: theme.spacing(1),
        },
      },
    },
  };
}
